/**
 * Config collection
 * 
 * @class Collection_Config
 */

Collection_Config = ( function( BaseCollection ) {
	var Collection_Config = function() {
		this.construct.apply( this, arguments );
	};

	$.extend( true, Collection_Config.prototype, BaseCollection.prototype, {
		/**
		 * @inheriteddoc Collection#fetch
		 * @returns promise
		 */
		fetch: function() {
			this.reset();
			return new Promise( function( resolve, reject ) {
				API.fetchConfig()
					.bind( this )
					.then( function( resp ) {
						if ( resp ) {
							// is presented catalogue section / or is geoblocked
							if ( resp.catalogue ) {
								this.parseData( resp );
								resolve();
							} else {
								reject( 'geoblocking' );
							}
						} else {
							reject();
						}
					} )
					.catch( function( err, status ) {
						App.throbberHide();
						App.notification( __( err ) );
						reject();
					} );
			}.bind( this ) )
		},

		/**
		 * parsing response to collection
		 * @param {object} config
		 */
		parseData: function( config ) {
			config.timeOffset = moment( config.currentTimeStamp ).diff( moment() );
			console.info( 'timeOffset: ' + config.timeOffset )
			this.push( config );
		}

	} );

	return Collection_Config;
} )( BaseCollection );



//////////////////
// WEBPACK FOOTER
// ./js/collection/collection_config.js
// module id = 7
// module chunks = 0